export default "__VITE_ASSET__e09ed5aa__"